import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import s from './FakePost.module.scss';
import { ReactComponent as Logo } from '../../../../assets/post-card-actions.svg';
import { toAbsoluteUrl } from '../../../../../_metronic/_helpers';

export default function FakePost({
    postText,
    userName,
    userImageInputObj,
    postImageInputObj, }) {
    const [contentRef, setContentRef] = useState(null);
    const [userAvatar, setUserAvatar] = useState('');
    const [postImage, setPostImage] = useState('');

    useEffect(() => {
        if (!contentRef) {
            return;
        }
        setUserAvatar(userImageInputObj.element.childNodes[0].style.backgroundImage);
        setPostImage(postImageInputObj.element.childNodes[0].style.backgroundImage);
    }, [contentRef, userImageInputObj,
        postImageInputObj])
    return (
        <div ref={setContentRef}>
            <div className={classNames(s.userDetails)}>
                <div
                    className={classNames(s.userImage)}
                    style={{ backgroundImage: userAvatar, }}>
                </div>
                <span className={classNames(s.userName)}>
                    {userName}
                </span>
                <img width="13px" style={{ marginLeft: '0.4rem' }} src={toAbsoluteUrl('/assets/Brand.svg')} alt="" />
            </div>
            <div className={classNames(s.postText)}>
                {postText}
            </div>
            <div
                className={classNames(s.postImage)}
                style={{ backgroundImage: postImage, }}>
            </div>
            <div
                className={classNames(s.postCardActions)}>
                <Logo
                    height="25" width="100%" style={{ float: 'left' }} />
            </div>
        </div>
    );
}
